import React,{Component} from 'react'
import FrameComponents from '../../FrameComponents';
import './index.css'
class dashboard extends Component {
  // 进入组件调用
  state = {
    name: 'sourcing_detail',
    sourcingMode:{}
  }
  componentDidMount() {
    // 设置页面标题
    document.title = 'DropshipMan-sourcing-detail';
    const shopify = window.shopify;
    // 添加全局点击事件监听
    if (shopify) {
      window.addEventListener('message', this.handleDataFromMainApp); // 接收主窗口数据
    }
  }
  // 接收数据
  handleDataFromMainApp = (ev) => {
    const _that = ev.data;
    if (_that?.params) {
      this.setState({
        sourcingMode: _that?.params
      })
    }
  
  }
  componentWillUnmount() {// 销毁监听
    // 移除全局点击事件监听
     window.removeEventListener('message', this.handleDataFromMainApp);
  }
  render() {
    return (
      <div>
        <FrameComponents name={this.state.name} sourcingMode={this.state.sourcingMode}/> 
      </div>
    );
    
  }
}

export default dashboard;

